import { render, staticRenderFns } from "./LoginChallenge.vue?vue&type=template&id=f13d2922&scoped=true"
import script from "./LoginChallenge.vue?vue&type=script&lang=js"
export * from "./LoginChallenge.vue?vue&type=script&lang=js"
import style0 from "./LoginChallenge.vue?vue&type=style&index=0&id=f13d2922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13d2922",
  null
  
)

export default component.exports